import React from "react";
import { Link } from "react-router-dom";
import AddToCalendarMenu from "./AddToCalendarMenu";
import { formatTimeRange } from "./calendarLinks";

// One livestream card: title, time range, optional host, add-to-calendar menu.
// Cards with a route are links with hover feedback; cards without render as a
// plain div (an href-less <a> is neither focusable nor meaningful to screen
// readers) and show no hover state.
function EventCard({ event }) {
  const isClickable = !!event.route;

  const content = (
    <React.Fragment>
      <div className="calendar-page__card-content">
        <div className="calendar-page__card-title">{event.title}</div>
        <div className="calendar-page__card-time">
          {formatTimeRange(event.startTime, event.durationMinutes)}
        </div>
        {event.host && (
          <div className="calendar-page__card-host">{event.host}</div>
        )}
      </div>
      <AddToCalendarMenu event={event} />
    </React.Fragment>
  );

  if (isClickable) {
    return (
      <Link
        to={event.route}
        className="calendar-page__card calendar-page__card--clickable"
      >
        {content}
      </Link>
    );
  }

  return <div className="calendar-page__card">{content}</div>;
}

export default EventCard;
